/* estados de la aplicacion author */
const state = {
  // para cargar home
  loading: false,
  showMensaje: false,
  globalMsj: {'bg': '#e53935', 'msj': 'saludos...'},
  showAlert: false,
  globalMsjAlert: {'bg': '#e53935', 'msj': 'saludos...'}
}

export default state
